export enum ClientRestrictionId {
  Login = 0,
  CreateWallet = 2,
  SwapFree = 3,
  MaximumLeverage = 4,
  MaximumMT4Accounts = 5,
  MaximumMT5Accounts = 6,
  InterestRatesDisabled = 7,
  ExcludeFromBonusCampaign = 9,
  ExcludeFromLuckyDraw = 10,
}

export enum ClientRestrictionName {
  Login = 'Login',
  CreateWallet = 'Create Wallet',
  SwapFree = 'Swap Free',
  MaximumLeverage = 'Maximum Leverage',
  MaximumMT4Accounts = 'Maximum MT4 Accounts',
  MaximumMT5Accounts = 'Maximum MT5 Accounts',
  InterestRatesDisabled = 'Interest Rates Disabled',
  ExcludeFromBonusCampaign = 'Exclude from Bonus Campaign',
  ExcludeFromLuckyDraw = 'Exclude from Lucky Draw',
}

export interface ToggleInterestRatesRestriction {
  hasInterestRatesRestriction: boolean
}

export interface ToggleExcludeFromBonusCampaignRestriction {
  hasBonusCampaignRestriction: boolean
}

export interface ToggleExcludeLuckyDraw {
  exclude: boolean
}
